"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceAutopayReceipt = exports.InvoiceAutopayReceiptType = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.InvoiceAutopayReceiptType = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    order_number: typebox_1.Type.String(),
    invoice_number: typebox_1.Type.String(),
    custom_message: typebox_1.Type.Optional(typebox_1.Type.String()),
    invoice_amount: typebox_1.Type.String(),
});
class InvoiceAutopayReceipt {
    constructor(data) {
        this.first_name = data.first_name;
        this.order_number = data.order_number;
        this.invoice_number = data.invoice_number;
        this.custom_message = data.custom_message;
        this.invoice_amount = data.invoice_amount;
    }
}
exports.InvoiceAutopayReceipt = InvoiceAutopayReceipt;
//# sourceMappingURL=invoice-autopay-receipt-type.js.map